/**
 * Copyright (c) 2020 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import ParticipantBirthdateComponent from './participant.birthdate.component';
import { hideModal, updateParticipantBirthdate } from '../../actions/actions';

export const mapStateToProps = (state) => {
  return {
    error: state.subject.errorUpdateParticipantBirthdate,
    isLoading: state.subject.isLoadingParticipantBirthdate,
    currentBirthdate: state.subject.phi.subjectInfo.data.participant.birthDate,
    participantId: state.subject.phi.subjectInfo.data.participant.subjectId
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    hide: () => {
      dispatch(hideModal());
    },
    updateParticipantBirthdate: (participantId, payload) => {
      dispatch(updateParticipantBirthdate(participantId, payload));
    }
  };
};

const ParticipantBirthdateModalContainer = connect(mapStateToProps, mapDispatchToProps)(ParticipantBirthdateComponent);

export default ParticipantBirthdateModalContainer;
